<div id="content">
  <div class="left-side" id="actions">
    <div id="menu" [ngClass]="{ visible: (isSideNavClosed() | async) }">
      <button
        mat-button
        class="menu-button"
        type="button"
        (click)="openSideNav()"
        aria-label="Open side navigation"
      >
        <mat-icon class="material-icons-outlined icon" aria-hidden="true"
          >menu</mat-icon
        >
        <span class="menu-label" i18n="@@ActionBarOpenSidePanelMenuBtn"
          >Menu</span
        >
      </button>
    </div>
    <div class="portfolio-heading" i18n="@@PortfolioManagement">
      Portfolio Management
    </div>
    <mat-divider
      vertical
      class="divider"
      [ngClass]="{ visible: (isSideNavClosed() | async) }"
    ></mat-divider>
    <div id="bulk-actions">
      @if (activeTab === 'active') {
      <button mat-icon-button [disabled]="disabled" id="update-action">
        <mat-icon
          matTooltipPosition="above"
          matTooltip="Update"
          class="material-icons-outlined"
          i18n-matTooltip="@@ActionBarUpdateBtnTooltip"
          >edit_note
        </mat-icon>
      </button>
      }
      <app-export
        [disabled]="disabled"
        [tooltipPosition]="'above'"
      ></app-export>
      @if (activeTab === 'active') {
      <app-bulk-share-order
        [disabled]="disabled"
        [tooltipPosition]="'above'"
      ></app-bulk-share-order>
      }
    </div>
  </div>
  <div class="right-side">
    <div id="order-selection">
      <button
        mat-flat-button
        [ngClass]="{ active: active.isActive }"
        id="active-order"
        #active="routerLinkActive"
        routerLinkActive
        [routerLink]="['/order-management/active']"
      >
        <ng-container i18n="@@ActionBarActiveOrdersBtn"
          >Active Orders
        </ng-container>
        ({{ ordersCountMetadata.active?.total }})
      </button>
      <button
        mat-flat-button
        [ngClass]="{ active: inactive.isActive }"
        id="inactive-order"
        #inactive="routerLinkActive"
        routerLinkActive
        [routerLink]="['/order-management/inactive']"
      >
        <ng-container i18n="@@ActionBarInactiveOrdersBtn"
          >Inactive Orders
        </ng-container>
        ({{ ordersCountMetadata.inactive?.total }})
      </button>
    </div>
  </div>
</div>
